// extracted by mini-css-extract-plugin
module.exports = {"ResetPassword":"ResetPassword_ResetPassword__zoAoZ","FormContainer":"ResetPassword_FormContainer__28WDA"};